@import './pk-side-panel.variables';

:host {
  @include transition(#{'left, right, width'}, 0.25s);

  @apply absolute top-0 flex h-full w-0 flex-col overflow-hidden bg-[color:--side-panel--background-color];
  @apply -right-[--side-panel--mobile-width] sm:-right-[--side-panel--desktop-width];

  box-shadow: var(--side-panel--box-shadow);
}

:host(.side-panel__left) {
  @apply -left-[--side-panel--mobile-width] sm:-left-[--side-panel--desktop-width];
}

:host(.is-open) {
  @apply left-auto right-0 w-[--side-panel--mobile-width] sm:w-[--side-panel--desktop-width];
}

:host(.is-open.side-panel__left) {
  @apply left-0 right-0;
}

::slotted([slot='content']) {
  @apply overflow-y-auto pb-[--side-panel--padding-bottom] pl-[--side-panel--padding-left] pr-[--side-panel--padding-right] pt-[--side-panel--padding-top];
}
